import React, { useState } from 'react';
import {
    ComponentSettingsManageFilters,
    BlocksContext,
    ComponentSettingsExternalVisualization,
    BlockType,
    ComponentSettings,
    DisplayMask,
    IReportOverlaysState,
    IKpiChartOverlaysSettings,
} from '@report-content';
import useFirstDatasetMasks from './hooks/useFirstDatasetMasks';
import { ElementType } from 'components/element-viewer';

export default function BlocksContextProvider({
    children,
    manageFiltersSettings,
    rendererBlocks,
    displayMasksList,
    elementInfo,
    reportOverlaysState,
    saveBlockOverlays,
}: {
    children: any;
    manageFiltersSettings: ComponentSettingsManageFilters | null;
    rendererBlocks: Array<BlockType<ComponentSettings>>;
    displayMasksList: Array<DisplayMask>;
    elementInfo?: ElementType;
    reportOverlaysState?: IReportOverlaysState;
    saveBlockOverlays?: (blockUid: string, settings: IKpiChartOverlaysSettings) => void;
}) {
    const [filterRules, setFilterRules] = useState<any>(null);
    const [extViz, setExtViz] = useState<ComponentSettingsExternalVisualization | null>(null);
    const [manageFiltersReady, setManageFiltersReady] = useState<boolean>(false);

    const handleSetFilterRules = (rules: any) => {
        if (JSON.stringify(rules) != JSON.stringify(filterRules)) {
            setFilterRules(rules);
        }
    };

    const handleSetExtViz = (newExtViz: ComponentSettingsExternalVisualization | null) => {
        setExtViz(newExtViz);
    };
    const getFilterMask = useFirstDatasetMasks(rendererBlocks, displayMasksList);

    return (
        <BlocksContext.Provider
            value={{
                manageFiltersSettings: manageFiltersSettings,
                filters: filterRules,
                setFilters: handleSetFilterRules,
                extViz: extViz,
                manageFiltersReady: manageFiltersReady,
                setExtViz: handleSetExtViz,
                setManageFiltersReady: (status: boolean) => {
                    setManageFiltersReady(status);
                },
                getFilterMask: getFilterMask,
                elementInfo: elementInfo,
                reportOverlaysState: reportOverlaysState,
                saveBlockOverlays: saveBlockOverlays,
            }}
        >
            {children}
        </BlocksContext.Provider>
    );
}
